import { render, staticRenderFns } from "./msgItem.vue?vue&type=template&id=560d2422&"
import script from "./msgItem.vue?vue&type=script&lang=js&"
export * from "./msgItem.vue?vue&type=script&lang=js&"
import style0 from "./msgItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports